// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5aacf5c2","667":"2f5047f7","977":"5f4ca7c5"}[chunkId] + ".chunk.js";
};